import { Box } from "@mui/material";

export function formatDateToReadable(dateString) {
  const date = new Date(dateString);
  const options = { day: "numeric", month: "long", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
}

export function ServerImage(props) {
  const { src, sx, ...rest } = props;

  const link =
    src && process.env.REACT_APP_HR_API_PRODUCTION_SERVER + "/static/" + src;

  return (
    <Box
      component="img"
      src={link}
      alt="image"
      sx={{ maxWidth: "100%", ...sx }}
      {...rest}
    />
  );
}
